/**
 * Utilitários genéricos para busca textual em coleções.
 */

/**
 * Normaliza valores para facilitar comparações insensíveis a acento/maiúsculas.
 * @param {string|number|null|undefined} value
 * @returns {string}
 */
export const normalizeSearchValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

/**
 * Cria uma função de verificação que avalia se algum valor derivado do item
 * contém o termo informado.
 *
 * @param {string} term Texto de busca inserido pelo usuário
 * @param {Array<Function|string>} selectors Funções ou chaves que serão avaliadas
 * @returns {(item: any) => boolean}
 */
export const createSearchMatcher = (term, selectors) => {
  const normalizedTerm = normalizeSearchValue(term);

  if (!normalizedTerm) {
    return () => true;
  }

  const selectorList = Array.isArray(selectors) ? selectors : [selectors];

  return (item) =>
    selectorList.some((selector) => {
      const value =
        typeof selector === 'function'
          ? selector(item)
          : item?.[selector];

      return normalizeSearchValue(value).includes(normalizedTerm);
    });
};

/**
 * Filtra itens pelo termo de busca.
 *
 * @param {Array<any>} items Lista original
 * @param {string} term Texto de busca
 * @param {Array<Function|string>} selectors Seletores que devem ser inspecionados
 * @returns {Array<any>}
 */
export const filterBySearchTerm = (items = [], term, selectors) => {
  const match = createSearchMatcher(term, selectors);
  return items.filter(match);
};

